import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { CheckCircle2, KeyRound } from "lucide-react";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const token = sp.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Almeno 6 caratteri");
    if (pw !== pw2) return toast.error("Le password non coincidono");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      setDone(true);
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      toast.error(errMsg(err, "Errore reset password"));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-zen-bg flex items-center justify-center px-6 py-12" data-testid="reset-password-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center mb-8">
          <img src="/brand/freelanzen-wordmark.png" alt="FreelanZen" className="h-10 w-auto object-contain"/>
        </Link>
        <div className="zen-card p-8">
          {!token ? (
            <div className="text-center">
              <p className="text-zen-alert text-sm">Link non valido o scaduto.</p>
              <Link to="/forgot-password" className="mt-4 inline-block text-zen-primary hover:underline text-sm">
                Richiedi un nuovo link
              </Link>
            </div>
          ) : done ? (
            <div className="text-center" data-testid="reset-done">
              <CheckCircle2 size={40} className="mx-auto text-zen-primary mb-3"/>
              <h2 className="font-heading text-2xl mb-2">Password aggiornata</h2>
              <p className="text-zen-ink2 text-sm">Ti stiamo reindirizzando al login…</p>
            </div>
          ) : (
            <>
              <h2 className="font-heading text-2xl mb-1">Scegli una nuova password</h2>
              <p className="text-zen-ink2 text-sm mb-6">Almeno 6 caratteri. Ti consigliamo di usarne uno mai visto prima.</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <Label htmlFor="pw">Nuova password</Label>
                  <Input
                    id="pw" data-testid="reset-pw" type="password" required minLength={6}
                    value={pw} onChange={(e) => setPw(e.target.value)}
                    className="mt-1.5"
                  />
                </div>
                <div>
                  <Label htmlFor="pw2">Conferma password</Label>
                  <Input
                    id="pw2" data-testid="reset-pw2" type="password" required minLength={6}
                    value={pw2} onChange={(e) => setPw2(e.target.value)}
                    className="mt-1.5"
                  />
                </div>
                <Button
                  type="submit" disabled={loading} data-testid="reset-submit"
                  className="w-full bg-zen-primary hover:bg-zen-primaryHover text-white rounded-full py-6"
                >
                  <KeyRound size={16} className="mr-2"/>
                  {loading ? "Aggiorno…" : "Aggiorna password"}
                </Button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
